import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PushTemplateApi } from 'api';
import type { PushTemplate } from 'api/methods/PushTemplateApi';

/**
 * [PushTemplate] Query key 생성
 * --
 */
export const pushTemplateQueryKeys = createQueryKeys('pushTemplate', {
  getPushTemplate: (
    idx: number,
    params?: { [key: string]: string | number }
  ) => [idx, params],
  getPushTemplates: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [PushTemplate] 푸시 알림 템플릿 전체 조회
 * --
 */
export const useGetPushTemplates = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: pushTemplateQueryKeys.getPushTemplates(params).queryKey,
    queryFn: () => PushTemplateApi.getPushTemplates(params),
    ...options,
  });
  return data;
};

/**
 * [PushTemplate] 푸시 알림 템플릿 상세 조회
 * --
 */
export const useGetPushTemplate = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: pushTemplateQueryKeys.getPushTemplate(idx, params).queryKey,
    queryFn: () => PushTemplateApi.getPushTemplate(idx, params),
  });

  return data;
};

/**
 * [PushTemplate] 푸시 알림 템플릿 생성
 * --
 */
export const useCreatePushTemplate = (body: PushTemplate) => {
  const { mutateAsync: createPushTemplate, ...result } = useMutation({
    mutationFn: (variables: PushTemplate) =>
      PushTemplateApi.createPushTemplate(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createPushTemplate, ...result };
};

/**
 * [PushTemplate] 푸시 알림 템플릿 수정
 * --
 */
export const useUpdatePushTemplate = (body: PushTemplate) => {
  const { mutateAsync: updatePushTemplate, ...result } = useMutation({
    mutationFn: (variables: PushTemplate) =>
      PushTemplateApi.updatePushTemplate(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updatePushTemplate, ...result };
};

/**
 * [PushTemplate] 푸시 알림 템플릿 삭제
 * --
 */
export const useDeletePushTemplate = (idx: number) => {
  const { mutateAsync: deletePushTemplate, ...result } = useMutation({
    mutationFn: (variables: number) =>
      PushTemplateApi.deletePushTemplate(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deletePushTemplate, ...result };
};
